/* eslint-disable react/prop-types */
import React, { memo } from 'react'
import styles from './styles.module.scss'
import { ColorPalette } from 'src/types/api'
import mobileCheckIcon from 'src/assets/icons/mobile-selection-check.svg'

interface PaletteItemProps {
  palette: ColorPalette
  index: number
  isSelected: boolean
  onSelect: (index: number) => void
  imageUrl: string
}

const PaletteItem: React.FC<PaletteItemProps> = memo(({ palette, index, isSelected, onSelect, imageUrl }) => {
  return (
    <div
      className={styles.gridItem}
      onClick={() => onSelect(index)}
      onKeyPress={(e) => e.key === 'Enter' && onSelect(index)}
      role="button"
      tabIndex={0}
      aria-label={`Select ${palette.name} color palette`}
      aria-pressed={isSelected}
    >
      <div className={`${styles.imageContainer} ${isSelected ? styles.selected : ''}`}>
        <div className={styles.backgroundImage} style={{ backgroundImage: `url(${imageUrl})` }} />
        {isSelected && <img src={mobileCheckIcon} alt="Selected" className={styles.mobileCheckIcon} />}

        {/* Color swatches positioned on the image */}
        {!!palette.colors?.length && (
          <div className={styles.colorShowcase}>
            {palette.colors.map((color, i) => (
              <div key={color.hex + i} className={styles.styleMainColor} style={{ backgroundColor: color.hex }} />
            ))}
          </div>
        )}
      </div>

      {/* Palette name below the image */}
      <div className={styles.paletteName}>{palette.name}</div>
    </div>
  )
})

PaletteItem.displayName = 'PaletteItem'

export default PaletteItem
